import React, { useEffect, useState } from "react";
import styled from 'styled-components';
import CustomDropdown from '../Components/CustomDropdown';
import SkipCheckbox from '../Components/SkipCheckbox';
import { categoryTypeQuestion } from 'constants/questionTypes';
import {words} from '../translations'




const Categories = (props) => {

  const { saveUpdatedAnswers,
    currentQuestionDet,
    question,
    description,
    categoryQues,
    organizationName,
    language,
    organizationInfo,
    custom_thanks,
    custom_title,
    public_intro,
    custom_category_intro,
    customHeader,
  } = props

  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedCategoryQues, setSelectedCategoryQues] = useState(false);
  const [selectedCategoryOptions, setSelectedCategoryOptions] = useState([]);
  const [isNA, setNA] = useState(false);
  const [isOpenEnded, setIsOpenEnded] = useState(false);
  const [openEndedText, setOpenEndedText] = useState('');

  useEffect(() => {
    if (categoryQues) {
      const CatQues = categoryQues.filter(cq =>
        cq.id === currentQuestionDet.category_question_id)?.[0]
      setSelectedCategoryQues(CatQues)
      if (CatQues?.answers) {
        setSelectedCategoryOptions(CatQues?.answers)
      } else {
      setSelectedCategoryOptions(false)
    }
    } 
  }, [categoryQues, currentQuestionDet])

  useEffect(() => {
    if (currentQuestionDet?.response) {
      if (currentQuestionDet?.response?.response === 'N/A') {
        setNA(true)
        setSelectedCategory('')
        setIsOpenEnded(false)
        setOpenEndedText('')
      } else if (currentQuestionDet?.response?.response === 'open_ended') {
        setNA(false)
        setSelectedCategory('')
        setIsOpenEnded(true)
        setOpenEndedText(currentQuestionDet?.response?.open_ended_text || '')
      } else if (selectedCategoryQues?.answers) {
        setSelectedCategory(
          selectedCategoryQues?.answers.filter(
            op => op.id === currentQuestionDet?.response.response
          )?.[0]
        )
        setNA(false)
        setIsOpenEnded(false)
        setOpenEndedText('')
      } else {
        setSelectedCategory('')
        setNA(false)
        setIsOpenEnded(false)
        setOpenEndedText('')
      }
    } else {
      setSelectedCategory('')
      setNA(false)
      setIsOpenEnded(false)
      setOpenEndedText('')
    }
  },[currentQuestionDet, selectedCategoryQues])

  function SaveResponse(response) {
    const Response = {
      ques_sort_order: currentQuestionDet?.id,
      id: selectedCategoryQues.id,
      response: response?.id, 
      subfactor: selectedCategoryQues?.subfactor,
      priority: selectedCategoryQues?.priority,
      role: selectedCategoryQues?.role,
      reverse: selectedCategoryQues?.reverse,
      clicked: true,
    }
    saveUpdatedAnswers(currentQuestionDet?.id, Response, categoryTypeQuestion)
    setSelectedCategory(selectedCategoryQues?.answers.find(op => op.id === Response.response))
  }

  function SaveOpenEndedResponse(text) {
    if (text.trim().length > 0) {
      const Response = {
        ques_sort_order: currentQuestionDet?.id,
        id: selectedCategoryQues.id,
        response: 'open_ended',
        open_ended_text: text,
        subfactor: selectedCategoryQues?.subfactor,
        priority: selectedCategoryQues?.priority,
        role: selectedCategoryQues?.role,
        reverse: selectedCategoryQues?.reverse,
        clicked: true,
      }
      saveUpdatedAnswers(currentQuestionDet?.id, Response, categoryTypeQuestion)
    } else {
      // When clearing text, keep open-ended selected but disable Next
      const Response = {
        ques_sort_order: currentQuestionDet?.id,
        id: selectedCategoryQues.id,
        response: 'open_ended',
        open_ended_text: '',
        subfactor: selectedCategoryQues?.subfactor,
        priority: selectedCategoryQues?.priority,
        role: selectedCategoryQues?.role,
        reverse: selectedCategoryQues?.reverse,
        clicked: false,
      }
      saveUpdatedAnswers(currentQuestionDet?.id, Response, categoryTypeQuestion)
    }
    setOpenEndedText(text)
  }

  const handleNAClick = () => {
    if (!isNA) {
      setNA(true)
      setSelectedCategory('')
      setIsOpenEnded(false)
      setOpenEndedText('')
      const Response = {
        ques_sort_order: currentQuestionDet?.id,
        id: selectedCategoryQues?.id,
        response: 'N/A',
        subfactor: selectedCategoryQues?.subfactor,
        priority: selectedCategoryQues?.priority,
        role: selectedCategoryQues?.role,
        reverse: selectedCategoryQues?.reverse,
        clicked: true,
      }
      saveUpdatedAnswers(currentQuestionDet?.id, Response, categoryTypeQuestion)
    } else {
      setNA(false)
      setSelectedCategory('')
      setIsOpenEnded(false)
      setOpenEndedText('')
      const Response = {
        ques_sort_order: currentQuestionDet?.id,
        id: selectedCategoryQues?.id,
        response: null,
        subfactor: selectedCategoryQues?.subfactor,
        priority: selectedCategoryQues?.priority,
        role: selectedCategoryQues?.role,
        reverse: selectedCategoryQues?.reverse,
        clicked: false,
      }
      saveUpdatedAnswers(currentQuestionDet?.id, Response, categoryTypeQuestion)
    }
  }

  const handleOpenEndedClick = () => {
    setIsOpenEnded(true)
    setNA(false)
    setSelectedCategory('')
    // Save a pending open-ended response to ensure Next is disabled until text is entered
    const Response = {
      ques_sort_order: currentQuestionDet?.id,
      id: selectedCategoryQues?.id,
      response: 'open_ended',
      open_ended_text: '',
      subfactor: selectedCategoryQues?.subfactor,
      priority: selectedCategoryQues?.priority,
      role: selectedCategoryQues?.role,
      reverse: selectedCategoryQues?.reverse,
      clicked: false,
    }
    saveUpdatedAnswers(currentQuestionDet?.id, Response, categoryTypeQuestion)
  }

  const getTitle = ()=>{
    // For the injected category intro, prefer the new localized title with fallback to existing text
    if(currentQuestionDet?.from === 'category_intro'){
      const titleObj = custom_category_intro?.title;
      if(titleObj && typeof titleObj === 'object'){
        const localized = titleObj?.[language];
        if(typeof localized === 'string' && localized.trim().length > 0){
          return localized;
        }
      }
      if(language === 'FR'){
        return custom_category_intro?.fr;
      }
      return custom_category_intro?.text;
    }

    if(selectedCategoryQues?.fr_name && language === 'FR'){
      return selectedCategoryQues?.fr_name
    }

    if(selectedCategoryQues?.es_name && language === 'ES'){
      return selectedCategoryQues?.es_name
    }

    if(selectedCategoryQues?.por && language === 'POR'){
      return selectedCategoryQues?.por
    }

    if(selectedCategoryQues?.name){
      return selectedCategoryQues?.name
    }

    return words["category_completed"][language]
  }

  const getDescription = () =>{
    // Render custom category intro if this is the inserted intro screen
    if(currentQuestionDet?.from === 'category_intro'){
      if(language === 'FR'){
        return custom_category_intro?.fr
      }
      return custom_category_intro?.text
    }

    if(selectedCategoryQues?.fr && language === 'FR'){
      return selectedCategoryQues?.fr
    }
    if(selectedCategoryQues?.fr_question && language === 'FR'){
      return selectedCategoryQues?.fr_question
    }
    if(selectedCategoryQues?.es && language === 'ES'){
      return selectedCategoryQues?.es
    }
    if(selectedCategoryQues?.por && language === 'POR'){
      return selectedCategoryQues?.por
    }
    if(selectedCategoryQues?.question){
      return selectedCategoryQues?.question
    }

    if(public_intro =='hockey_participants'){
      return language === 'EN' ? EN1 : FR1

    }
    if(custom_thanks){
      if(language === 'FR'){
        return custom_thanks?.fr
      }

      return custom_thanks?.text
    }
    return words["category_completed2"][language].replace('{organizationName}',organizationName)
  }

  const renderInlineBold = (text) => {
    const parts = String(text).split(/(\*\*[^*]+?\*\*)/g)
    return parts.map((part, idx) => {
      if (part.startsWith('**') && part.endsWith('**')) {
        return <strong key={idx}>{part.slice(2, -2)}</strong>
      }
      return part
    })
  }

  const renderSmallText = (text) => {
    const parts = String(text).split(/(<small>[^<]+<\/small>)/g)
    return parts.map((part, idx) => {
      if (part.startsWith('<small>') && part.endsWith('</small>')) {
        const content = part.slice(7, -8)
        return <SmallText key={idx}>{renderInlineBold(content)}</SmallText>
      }
      return renderInlineBold(part)
    })
  }

  const renderMarkdownLite = (content) => {
    if (!content) return null
    if (React.isValidElement(content)) return content

    const normalized = String(content)
      .replace(/\r\n|\r/g, '\n')
      .replace(/\\n/g, '\n')

    const paragraphs = normalized.split(/\n{2,}/)
    return paragraphs.map((para, pIdx) => {
      const lines = para.split(/\n/)
      return (
        <p key={pIdx}>
          {lines.map((line, lIdx) => (
            <React.Fragment key={lIdx}>
              {renderSmallText(line)}
              {lIdx < lines.length - 1 ? <br /> : null}
            </React.Fragment>
          ))}
        </p>
      )
    })
  }

  const getCustomTitle = () =>{
    if(custom_title?.EN){
      return custom_title[language]
    }
    return words['category'][language]
  }


  return (
    <CategoriesContainer>
      {currentQuestionDet?.from !== 'category_intro' && (
        customHeader?.useImageAsQualifier && customHeader?.imageUrl ? (
          <HeaderImage
            src={customHeader.imageUrl}
            alt=""
            $height={customHeader.imageHeight}
          />
        ) : (
          <Title style={{color: organizationInfo?.custom_survey_header_color || undefined}}>{getCustomTitle()}</Title>
        )
      )}
      <QuestionText>{getTitle()}</QuestionText>
      <Description questionLength={selectedCategoryQues?.question?.length} >{renderMarkdownLite(getDescription())}</Description>
      {selectedCategoryOptions && <CustomDropdown
        id={`sel_${currentQuestionDet?.id}`}
        listId={`lists_${currentQuestionDet?.id}`}
        value={isOpenEnded ? 'open_ended' : selectedCategory}
        onSelect={(resp) => { setNA(false); setIsOpenEnded(false); setOpenEndedText(''); SaveResponse(resp) }}
        language={language}
        options={selectedCategoryOptions}
        groupTitles={selectedCategoryQues?.group_titles}
        allowOpenEnded={selectedCategoryQues?.allow_open_ended}
        openEndedName={selectedCategoryQues?.open_ended_name}
        openEndedNameFr={selectedCategoryQues?.open_ended_name_fr}
        onOpenEndedClick={handleOpenEndedClick} />}

      <AnimatedTextInputContainer isVisible={isOpenEnded}>
        <TextInput
          value={openEndedText}
          onChange={(e) => SaveOpenEndedResponse(e.target.value)}
          placeholder={language === 'FR' ? selectedCategoryQues?.open_ended_name_fr : selectedCategoryQues?.open_ended_name}
          maxLength={50}
        />
      </AnimatedTextInputContainer>

      {(selectedCategoryQues?.allow_skip || question?.allowSkip) && (
        <SkipCheckbox
          id={`skip_${currentQuestionDet?.id}`}
          selected={isNA}
          onClick={handleNAClick}
          language={language}
        />
      )}

    </CategoriesContainer>
  );
};

export default Categories;

const CategoriesContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width:calc(100%);
  max-width:600px;
  padding-bottom:150px;
  padding-top:20px;
`;

const HeaderImage = styled.img`
  display: block;
  max-width: 100%;
  height: ${props => (props.$height ? `${props.$height}px` : "auto")};
  margin-bottom: 16px;
`;

const QuestionText = styled.h2`
  margin-bottom: 1rem;
  color:#2A3039;
  font-size: 20px;
  font-weight: 600;
`;

const Dropdown = styled.select`
  font-size: 1rem;
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

const Title = styled.div`
color: #2D70E2;
text-transform: uppercase;
font-size:14px;
font-weight:600;
`

const Description = styled.div`
color: #2A3039;
font-family: 'Raleway';
font-style: normal;
font-weight: 400;
font-size: 16px;
line-height:1.6;
margin-bottom:26px;

@media(max-height:700px){
  font-size:${props => props.questionLength > 200 ? '14px' : '16px'};
}

@media(max-height:550px){
  font-size:${props => props.questionLength > 200 ? '12px' : '16px'};
}
`

const SmallText = styled.small`
  font-size: calc(1rem - 1px);
  line-height: 1.2;
`

const AnimatedTextInputContainer = styled.div`
  max-height: ${props => props.isVisible ? '50px' : '0'};
  opacity: ${props => props.isVisible ? '1' : '0'};
  overflow: visible;
  transition: all 0.3s ease-in-out;
  margin-bottom: ${props => props.isVisible ? '16px' : '0'};
  transform: ${props => props.isVisible ? 'translateY(0)' : 'translateY(-10px)'};
`

const TextInput = styled.input`
  width: 100%;
  max-width: 600px;
  padding: 12px 16px;
  border: 2px solid #E5E7EB;
  border-radius: 8px;
  font-size: 14px;
  color: #374151;
  outline: none;
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  background-color: #F9FAFB;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease-in-out;

  &:focus {
    border-color: #3B82F6;
    background-color: #FFFFFF;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
  }

  &:hover {
    border-color: #D1D5DB;
    background-color: #FFFFFF;
  }

  &::placeholder {
    color: #9CA3AF;
    font-style: italic;
  }
`

 

const EN1 = (<div>
  <p>
  For the remainder of the survey, we will be asking about your personal experience with the environment and culture of hockey in Canada. However, to ensure your feedback reflects the current state of hockey, please focus only on your experiences from the <strong>past five years</strong>.
  </p>
  <p>
  As you answer, think about your recent hockey participation and how it has shaped your experience. Your honest responses will help us understand the opportunities for achieving healthy culture in the future of hockey.
  </p>
</div>)

const FR1 = (<div>
  <p>
  Pour le reste du sondage, nous vous demanderons de partager votre expérience personnelle de l'environnement et de la culture du hockey au Canada. Cependant, pour garantir que vos commentaires reflètent l'état actuel du hockey, veuillez vous concentrer uniquement sur vos expériences des <strong>cinq dernières années</strong>.
  </p>
  <p>
  En répondant, réfléchissez à votre participation récente au hockey et à la manière dont elle a façonné votre expérience. Vos réponses honnêtes nous aideront à comprendre les opportunités pour atteindre une culture saine dans l'avenir du hockey.
  </p>
</div>
)